export default {
  SET_STATE: 'payments/SET_STATE',
  FETCH_PAYMENTS: 'payments/FETCH_PAYMENTS',
  CREATE_PAYMENT: 'payments/CREATE_PAYMENT',
  FETCH_SINGLE: 'payments/FETCH_SINGLE',
  UPDATE_PAYMENT: 'payments/UPDATE_PAYMENT',
}
